import Permissions from "./Permissions";

export default {
    install(Vue) {
        // Make auth and its properties reactive.
        let app = new Vue({
            data: {
                permissions: new Permissions()
            }
        });
        Vue.prototype.$permissions = app.permissions;
    }
}
  